import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TitleService {
    private titleStream = new BehaviorSubject('');

    constructor() {}

    public setTitle(title: string) {
        this.titleStream.next(title);
    }

    public get title$() {
        return this.titleStream.asObservable();
    }
}
